import React, { Component } from 'react'

class Home extends Component {
  render() {
    return (
      <div className='container'>
        <div className='inside centralize'>
          <span className='site-name'>ClubHub</span>
          <span className='site-payoff'>
            la gestione smart della tua associazione
          </span>
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js